import React from "react";
import "../styles/footer.scss"


function Footer() {
    return <div className="footer block"> <div className="left"><p>АДВОКАТ ШАКИРОВ Л. Н.</p><p>ПРОФЕССИОНАЛЬНЫЙ АДВОКАТ В КАЗАНИ</p></div><div className="right"><a href="https://sanatstudio.ru/">СОЗДАНО: SANATSTUDIO</a></div></div>
}

export default Footer;